import {delay, put} from 'redux-saga/effects';
import {RESET_ERROR} from "../../constants/ErrorConstants";

export function* handleGenericError() {
    yield delay(5000);
    yield put({type: RESET_ERROR});
}

export function* handleLoginError() {
    yield delay(5000);
    yield put({type: RESET_ERROR});
}